export default __webpack_public_path__ + "static/ab-screen-2-af58f802c4672542bbd78fd238e9a0ae.jpg";